import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LocalizedText from '@LocalizedText';
import { performAction } from '@app/actions/customizeActions';

import Button from '@components/buttons/Button';
import './RotateTool.scss';

const RotateTool = ({ performAction }) => {
  const rotateArt = ({ target }) => {
    const clockWise = target.classList.contains('cw');
    performAction('fieldRotate', {
      deg: clockWise ? 90 : -90,
    });
  };

  return (
    <div id="qau-rotate-tool">
      <div className="rotate-tool-title">
        <LocalizedText id="qau-rotate-art-tool-text" />
      </div>
      <div className="rotate-tool-button-group">
        <Button className="rotate-btn cw" onClick={rotateArt} />
        <Button className="rotate-btn ccw" onClick={rotateArt} />
      </div>
    </div>
  );
};

RotateTool.propTypes = {
  performAction: PropTypes.func.isRequired,
};

export default connect(null, { performAction })(RotateTool);
